/*!
 * GARAGE BRICKS theme — header, reveal, product form, variant picker, gallery,
 * sticky add-to-cart and cart drawer (Shopify AJAX Cart API).
 */
(function () {
  'use strict';
  var GB = window.GB = window.GB || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (GB.routes && GB.routes.root) || '/';
  var url = function (path) { return (root.replace(/\/$/, '') + path); };

  /* ---------- money (Shopify money_format) ---------- */
  GB.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || GB.moneyFormat || '¥{{amount_no_decimals}}';
    var fmt = function (n, decimals, th, dec) {
      th = th === undefined ? ',' : th; dec = dec === undefined ? '.' : dec;
      var num = (n / 100).toFixed(decimals);
      var parts = num.split('.');
      var ints = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return ints + (parts[1] ? dec + parts[1] : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', '');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        default: return fmt(cents, 2);
      }
    });
  };
  var money = function (c) { return GB.formatMoney(c); };

  /* ---------- toast ---------- */
  var toastTimer;
  GB.toast = function (msg) {
    var t = $('[data-gb-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  };

  /* ---------- header: hide on scroll down, show on scroll up ---------- */
  function initHeader() {
    var wrap = $('[data-gb-header]'); if (!wrap) return;
    var last = window.scrollY, ticking = false;
    var h = wrap.offsetHeight;
    document.documentElement.style.setProperty('--gb-header-h', (($('.gb-header', wrap) || wrap).offsetHeight) + 'px');
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY, menuOpen = !!$('.gb-menu[open]');
        if (!menuOpen && wrap.getAttribute('data-autohide') !== 'false') {
          if (y > last + 6 && y > h * 2) wrap.classList.add('is-hidden');
          else if (y < last - 6 || y < h) wrap.classList.remove('is-hidden');
        }
        last = y; ticking = false;
      });
    }, { passive: true });
    var menu = $('.gb-menu', wrap);
    if (menu) {
      menu.addEventListener('toggle', function () { document.documentElement.classList.toggle('gb-drawer-open', menu.open); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.open) { menu.open = false; $('summary', menu).focus(); } });
    }
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(scope) {
    var els = $$('.gb-reveal:not(.is-in)', scope);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window) || document.body.classList.contains('gb-motion-off')) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- cart ---------- */
  var Cart = GB.cart = {
    state: null,
    drawer: null,
    lastFocus: null,
    init: function () {
      this.drawer = $('[data-gb-drawer]');
      var json = $('[data-gb-cart-json]');
      if (json) { try { this.state = JSON.parse(json.textContent); } catch (e) { this.state = null; } }
      if (this.state) this.render(this.state);
      var self = this;
      document.addEventListener('click', function (e) {
        var open = e.target.closest('[data-gb-cart-open]');
        if (open && self.drawer && GB.cartType === 'drawer') { e.preventDefault(); self.open(open); return; }
        if (e.target.closest('[data-gb-drawer-close]')) { e.preventDefault(); self.close(); return; }
        var rm = e.target.closest('[data-gb-line-remove]');
        if (rm) { e.preventDefault(); self.change(rm.getAttribute('data-key'), 0); return; }
        var step = e.target.closest('[data-gb-line-step]');
        if (step) {
          e.preventDefault();
          var line = step.closest('[data-gb-line]');
          var q = parseInt(line.getAttribute('data-qty'), 10) + parseInt(step.getAttribute('data-gb-line-step'), 10);
          self.change(line.getAttribute('data-key'), Math.max(0, q));
        }
      });
      document.addEventListener('change', function (e) {
        var inp = e.target.closest('[data-gb-line-input]');
        if (inp) { var line = inp.closest('[data-gb-line]'); self.change(line.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0)); }
      });
      document.addEventListener('keydown', function (e) {
        if (!self.isOpen()) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'Tab') self.trap(e);
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh(); });
    },
    isOpen: function () { return this.drawer && this.drawer.classList.contains('is-open'); },
    open: function (from) {
      if (!this.drawer) { window.location.href = GB.routes.cart; return; }
      this.lastFocus = from || document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('gb-drawer-open');
      var panel = $('.gb-drawer__panel', this.drawer);
      setTimeout(function () { panel.focus(); }, 30);
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('gb-drawer-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    trap: function (e) {
      var f = $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', $('.gb-drawer__panel', this.drawer)).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },
    busy: function (on) {
      var body = this.drawer && $('[data-gb-drawer-body]', this.drawer);
      if (body) body.setAttribute('aria-busy', on ? 'true' : 'false');
    },
    error: function (msg) {
      var el = this.drawer && $('[data-gb-drawer-error]', this.drawer);
      if (!el) { if (msg) GB.toast(msg); return; }
      el.textContent = msg || ''; el.hidden = !msg;
    },
    refresh: function () {
      var self = this;
      return fetch(url('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.state = c; self.render(c); return c; });
    },
    change: function (key, qty) {
      var self = this;
      self.busy(true); self.error('');
      return fetch(url('/cart/change.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      }).then(function (c) {
        self.state = c; self.render(c);
        var line = (c.items || []).filter(function (i) { return i.key === key; })[0];
        if (line && line.quantity < qty) self.error('在庫数を超えるため、数量を' + line.quantity + 'に調整しました。');
      }).catch(function (err) {
        self.error((err && (err.description || err.message)) || GB.strings.error);
        return self.refresh();
      }).then(function () { self.busy(false); });
    },
    add: function (form) {
      var fd = new FormData(form);
      return fetch(url('/cart/add.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      });
    },
    lineHTML: function (it) {
      var img = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
      var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var alt = (it.featured_image && it.featured_image.alt) || it.product_title;
      var meta = [];
      if (!it.product_has_only_default_variant && it.options_with_values) {
        it.options_with_values.forEach(function (o) { meta.push(esc(o.name) + '：' + esc(o.value)); });
      }
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) meta.push(esc(it.selling_plan_allocation.selling_plan.name));
      if (it.properties) Object.keys(it.properties).forEach(function (k) {
        var v = it.properties[k]; if (!v || k.charAt(0) === '_') return; meta.push(esc(k) + '：' + esc(v));
      });
      var disc = (it.line_level_discount_allocations || []).map(function (d) {
        return '<p class="gb-line__disc">' + esc(d.discount_application && d.discount_application.title) + '（-' + money(d.amount) + '）</p>';
      }).join('');
      var price = it.original_line_price > it.final_line_price
        ? '<s>' + money(it.original_line_price) + '</s>' + money(it.final_line_price)
        : money(it.final_line_price);
      return '<div class="gb-line" data-gb-line data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<a class="gb-line__img" href="' + esc(it.url) + '">' + (src ? '<img src="' + esc(src) + '" alt="' + esc(alt) + '" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div class="gb-line__info">' +
          '<p class="gb-line__title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
          (meta.length ? '<p class="gb-line__meta">' + meta.join('<br>') + '</p>' : '') +
          '<p class="gb-line__price">' + price + '</p>' + disc +
          '<div class="gb-line__actions">' +
            '<div class="gb-qty" role="group" aria-label="' + esc(GB.strings.qty) + '">' +
              '<button type="button" data-gb-line-step="-1" aria-label="数量を減らす">−</button>' +
              '<input type="number" min="0" value="' + it.quantity + '" data-gb-line-input aria-label="' + esc(it.product_title) + ' の数量">' +
              '<button type="button" data-gb-line-step="1" aria-label="数量を増やす">＋</button>' +
            '</div>' +
            '<button type="button" class="gb-line__remove" data-gb-line-remove data-key="' + esc(it.key) + '">' + esc(GB.strings.remove) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    },
    render: function (c) {
      $$('[data-gb-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
      $$('[data-gb-cart-count-text]').forEach(function (el) { el.textContent = c.item_count; });
      if (!this.drawer) return;
      var lines = $('[data-gb-drawer-lines]', this.drawer);
      var empty = $('[data-gb-drawer-empty]', this.drawer);
      var foot = $('[data-gb-drawer-foot]', this.drawer);
      var hasItems = c.item_count > 0;
      lines.innerHTML = hasItems ? c.items.map(this.lineHTML).join('') : '';
      empty.hidden = hasItems; foot.hidden = !hasItems;
      $('[data-gb-drawer-total]', this.drawer).textContent = money(c.total_price);
      var d = $('[data-gb-drawer-discounts]', this.drawer);
      d.innerHTML = (c.cart_level_discount_applications || []).map(function (a) {
        return '<p class="gb-drawer__disc"><span>' + esc(a.title) + '</span><span>-' + money(a.total_allocated_amount) + '</span></p>';
      }).join('');
    }
  };

  /* ---------- product form (add to cart + variant picker) ---------- */
  function initProductForms(scope) {
    $$('form[data-gb-product-form]', scope).forEach(function (form) {
      if (form.__gb) return; form.__gb = true;
      form.addEventListener('submit', function (e) {
        if (GB.cartType !== 'drawer' || !window.fetch) return; // native POST to /cart/add → cart page
        e.preventDefault();
        var btn = $('[data-gb-submit]', form);
        var err = $('[data-gb-error]', form);
        if (btn && (btn.disabled || btn.getAttribute('aria-busy') === 'true')) return;
        if (err) { err.hidden = true; err.textContent = ''; }
        if (btn) btn.setAttribute('aria-busy', 'true');
        Cart.add(form).then(function () {
          return Cart.refresh();
        }).then(function () {
          Cart.open(btn);
        }).catch(function (d) {
          var msg = (d && (d.description || d.message)) || GB.strings.error;
          if (err) { err.textContent = msg; err.hidden = false; } else GB.toast(msg);
        }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
      });
    });

    $$('[data-gb-qty]', scope).forEach(function (q) {
      if (q.__gb) return; q.__gb = true;
      var inp = $('input', q), minus = $('[data-gb-qty-minus]', q), plus = $('[data-gb-qty-plus]', q);
      var sync = function () { var v = parseInt(inp.value, 10) || 1; inp.value = Math.min(99, Math.max(1, v)); minus.disabled = inp.value <= 1; };
      minus.addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) - 1; sync(); });
      plus.addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) + 1; sync(); });
      inp.addEventListener('change', sync); sync();
    });

    $$('[data-gb-pf]', scope).forEach(function (pf) {
      if (pf.__gb) return; pf.__gb = true;
      var variants = [];
      try { variants = JSON.parse($('[data-gb-variants]', pf).textContent); } catch (e) { return; }
      var fieldsets = $$('[data-gb-option]', pf);
      if (!fieldsets.length) return;
      var low = parseInt(pf.getAttribute('data-low'), 10) || 5;
      var update = function () {
        var sel = fieldsets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
        var btn = $('[data-gb-submit]', pf), lbl = $('[data-gb-submit-label]', pf);
        if (!v) {
          if (btn) btn.disabled = true;
          if (lbl) lbl.textContent = 'この組み合わせはありません';
          return;
        }
        $('[data-gb-variant-id]', pf).value = v.id;
        var was = $('[data-gb-price-was]', pf), badge = $('[data-gb-price-badge]', pf), unit = $('[data-gb-unit]', pf);
        $('[data-gb-price-now]', pf).textContent = money(v.price);
        var sale = v.compare_at_price > v.price;
        if (was) { was.hidden = !sale; was.textContent = sale ? money(v.compare_at_price) : ''; }
        if (badge) badge.hidden = !sale;
        if (unit) { unit.hidden = !v.unit; unit.textContent = v.unit || ''; }
        var st = $('[data-gb-stock]', pf);
        if (st) {
          st.className = 'gb-stock';
          if (!v.available) { st.classList.add('gb-stock--out'); st.textContent = GB.strings.soldOut; }
          else if (v.management === 'shopify' && v.policy === 'deny' && v.qty > 0 && v.qty <= low) { st.classList.add('gb-stock--low'); st.textContent = '残りわずか'; }
          else st.textContent = '在庫あり';
        }
        if (btn) btn.disabled = !v.available;
        if (lbl) lbl.textContent = v.available ? btn.getAttribute('data-label') : GB.strings.soldOut;
        // mark unavailable values for the first option
        fieldsets.forEach(function (fs, idx) {
          $$('input', fs).forEach(function (inp) {
            var ok = variants.some(function (x) { return x.available && x.options[idx] === inp.value && x.options.every(function (o, j) { return j === idx || o === sel[j]; }); });
            inp.classList.toggle('is-unavailable', !ok);
          });
        });
        if (pf.getAttribute('data-url') && window.history.replaceState && location.pathname.indexOf('/products/') > -1) {
          window.history.replaceState({}, '', pf.getAttribute('data-url') + '?variant=' + v.id);
        }
        document.dispatchEvent(new CustomEvent('gb:variant', { detail: { variant: v, root: pf } }));
        $$('[data-gb-sticky-price]').forEach(function (el) { el.textContent = money(v.price); });
      };
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      update();
    });
  }

  /* ---------- gallery ---------- */
  function initGallery(scope) {
    $$('[data-gb-gallery]', scope).forEach(function (g) {
      if (g.__gb) return; g.__gb = true;
      var main = $('[data-gb-gallery-main]', g);
      var slides = $$('[data-gb-slide]', g);
      var thumbs = $$('[data-gb-thumb]', g);
      var count = $('[data-gb-gallery-count]', g);
      if (!main || !slides.length) return;
      var current = 0;
      var setCurrent = function (i) {
        current = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      };
      var go = function (i, instant) {
        i = (i + slides.length) % slides.length;
        main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: (reduce || instant) ? 'auto' : 'smooth' });
        setCurrent(i);
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = $('[data-gb-gallery-prev]', g), next = $('[data-gb-gallery-next]', g);
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      var t;
      main.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (main.scrollWidth <= main.clientWidth + 2) return;
          var i = Math.round(main.scrollLeft / main.clientWidth);
          if (i !== current) setCurrent(Math.max(0, Math.min(slides.length - 1, i)));
        }, 60);
      }, { passive: true });
      /* カラーなどを選んだら、ページを動かさずに表示中の画像をその場で切り替える */
      var showMedia = function (id) {
        if (!id) return;
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(id); });
        if (idx < 0) return;
        if (main.scrollWidth > main.clientWidth + 2) { go(idx, true); return; }
        /* 縦並び表示のときは、選んだ画像を先頭に入れ替える（スクロールしない） */
        if (main.firstElementChild !== slides[idx]) main.insertBefore(slides[idx], main.firstElementChild);
      };
      document.addEventListener('gb:variant', function (e) {
        var pf = e.detail.root, own = g.closest('.gb-buy, .gb-pdp, section');
        if (pf && own && !own.contains(pf)) return;
        showMedia(e.detail.variant && e.detail.variant.image);
      });
      setCurrent(0);
      var vj = (g.closest('.gb-buy, .gb-pdp, section') || document).querySelector('[data-gb-variants]');
      var vid = new URLSearchParams(location.search).get('variant');
      if (vj && vid) { try { var vv = JSON.parse(vj.textContent).filter(function (x) { return String(x.id) === vid; })[0]; if (vv) showMedia(vv.image); } catch (er) {} }
    });
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky() {
    var bar = $('[data-gb-sticky-atc]'); if (!bar) return;
    var target = $('[data-gb-main-atc-wrap] [data-gb-submit]') || $('[data-gb-main-atc]');
    var form = target && target.closest('form');
    if (!target || !form || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      var e = en[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      bar.setAttribute('aria-hidden', bar.classList.contains('is-on') ? 'false' : 'true');
    });
    io.observe(target);
    var btn = $('[data-gb-sticky-btn]', bar);
    if (btn) btn.addEventListener('click', function () {
      var main = $('[data-gb-submit]', form);
      if (main && main.disabled) { target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
      if (form.requestSubmit) form.requestSubmit(main); else main.click();
    });
    document.addEventListener('gb:variant', function (e) {
      if (!btn) return;
      btn.disabled = !e.detail.variant.available;
      btn.textContent = e.detail.variant.available ? btn.getAttribute('data-label') : GB.strings.soldOut;
    });
  }

  /* ---------- in-page anchors: smooth + respect reduced motion ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]'); if (!a) return;
      var id = a.getAttribute('href').slice(1); if (!id) return;
      var el = document.getElementById(id); if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + id);
    });
  }

  function initAll(scope) { initReveal(scope); initProductForms(scope); initGallery(scope); }

  function boot() {
    initHeader(); Cart.init(); initAll(document); initSticky(); initAnchors();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); if (e.target.querySelector('[data-gb-header]')) initHeader(); });
})();
